/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{_ as e}from"../../../../chunks/tslib.es6.js";import{ShaderTechniqueConfiguration as o,parameter as r}from"../core/shaderTechnique/ShaderTechniqueConfiguration.js";class s extends o{constructor(){super(...arguments),this.receiveShadows=!0}}e([r()],s.prototype,"receiveShadows",void 0);export{s as ShadowConfiguration};
